import React, { useEffect, useRef, useState } from 'react'
import { TextBox } from 'srcReact/components/common2/TextBox'
import PureTitle from '../PureTitle'
import styles from './styles.module.scss'
import parentStyles from '../../styles.module.scss'
import { useTranslation } from 'react-i18next'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import RichTextEditor from 'srcReact/components/common2/RichTextEditor'
import Button from 'srcReact/components/common2/Button'
import { isEmpty } from 'srcReact/helpers/validator'
import { mixrActions } from 'srcReact/Mixr/actions'
import { useDispatch, useSelector } from 'react-redux'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Spinner from 'srcReact/components/common2/Spinner'
import { decode } from 'html-entities/lib/index'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Icon from 'srcReact/components/icons/Icon'

export default function BasicInfo({
  showNextSection,
  hideNextButton,
  isMobile,
  allGroups,
  fromGroupId,
  openEditMixrPopup,
  setDataToUpdateForRecMixr,
  editMode,
  previewEditMode,
  handleSaveDraft,
  groupLoading
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [nameRef, setNameRef] = useState(null)
  const [selectGroupRef, setSelectGroupRefRef] = useState(null)
  const descriptionRef = useRef(null)
  const [groups, setGroups] = useState([])
  const [valueChanged, setValueChanged] = useState(false)

  const [name, setName] = useState({
    name: 'mixrName',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [description, setDescription] = useState({
    name: 'mixrDescription',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [group, setGroup] = useState({
    name: 'mixrGroup',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [focusedMode, setFocusedMode] = useState(false)
  const [selectedGrp, setSelectedGrp] = useState({
    value: -1,
    label: t('event.create.basicInfo.selectGroupPlaceholder'),
    group: null
  })

  useEffect(() => {
    if (fromGroupId > 0) {
      const group = allGroups ? allGroups.find((g) => g.group_id == fromGroupId) : null
      if (group) {
        setSelectedGrp({
          value: group.group_id,
          label: (
            <span>
              <span>{decode(group.group_name)}</span> &nbsp;
              <span>
                {group.group_role === 'organizer'
                  ? `(${t('components.avatar.organizer')})`
                  : group.group_role === 'co-organizer'
                  ? `(${t('components.avatar.co-organizer')})`
                  : ''}
              </span>
              {group.type === 'expertise' ? (
                <Icon name='star-solid' styleModifier={styles.expertiseGrpIcon} size='large24' />
              ) : (
                ''
              )}
            </span>
          ),
          group: group
        })
      }
    }
  }, [fromGroupId, allGroups, previewEditMode])

  const {
    mixr: {
      mixr: { id, name: mixrName, description: mixrDescription, recurrence, group: selectedGroup },
      editLoading,
      editSuccess
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (editMode || previewEditMode) {
      setName({ ...name, value: mixrName || '' })
    }
  }, [editMode, previewEditMode, mixrName])
  useEffect(() => {
    if (editMode || previewEditMode) {
      setDescription({ ...description, value: mixrDescription || '' })
    }
  }, [editMode, previewEditMode, mixrDescription])

  useEffect(() => {
    if (editMode || previewEditMode) {
      if (selectedGroup) {
        let groupName = selectedGroup.group_name || selectedGroup.name

        groupName = (
          <span>
            <span>{decode(groupName)}</span> &nbsp;
            <span>
              {selectedGroup.group_role === 'organizer'
                ? `(${t('components.avatar.organizer')})`
                : selectedGroup.group_role === 'co-organizer'
                ? `(${t('components.avatar.co-organizer')})`
                : ''}
            </span>
            {selectedGroup.type === 'expertise' ? (
              <Icon name='star-solid' styleModifier={styles.expertiseGrpIcon} size='large24' />
            ) : (
              ''
            )}
          </span>
        )
        setSelectedGrp({
          value: selectedGroup.group_id || selectedGroup.id,
          label: groupName,
          group: selectedGroup
        })
      } else {
        setSelectedGrp({
          value: -1,
          label: t('event.create.basicInfo.selectGroupPlaceholder'),
          group: null
        })
      }
    }
  }, [editMode, previewEditMode, selectedGroup])

  useEffect(() => {
    if (allGroups.length > 0) {
      const groupList = []
      for (let i = 0; i < allGroups.length; i++) {
        const text = (
          <span>
            <span>{decode(allGroups[i].group_name)}</span> &nbsp;
            <span>
              {allGroups[i].group_role === 'organizer'
                ? `(${t('components.avatar.organizer')})`
                : allGroups[i].group_role === 'co-organizer'
                ? `(${t('components.avatar.co-organizer')})`
                : ''}
            </span>
            {allGroups[i].type === 'expertise' ? (
              <Icon name='star-solid' styleModifier={styles.expertiseGrpIcon} size='large24' />
            ) : (
              ''
            )}
          </span>
        )
        groupList.push({ value: allGroups[i].group_id, label: text, group: allGroups[i] })
      }
      setGroups([...groupList])
    }
  }, [allGroups])

  useEffect(() => {
    if (editMode && editSuccess) {
      setValueChanged(false)
    }
  }, [editSuccess])

  const handleNameChange = (e) => {
    setValueChanged(true)
    setFocusedMode(false)
    if (e && e.target) {
      const { name, value } = e.target
      setName({
        ...name,
        value: value,
        errorMessage: value.length === 0 ? t('event.create.clientErrors.nameRquired') : '',
        hasError: value.length === 0
      })
    }
  }

  const handleNameBlur = (e) => {
    if (e && e.target) {
      const { name, value } = e.target
      if (isEmpty(value) && nameRef.current) {
        nameRef.current.focus()
        setName({
          ...name,
          hasError: true,
          errorMessage: t('event.create.clientErrors.nameRquired')
        })
        return false
      } else if (!editMode) {
        dispatch(mixrActions.setMixrData([{ key: 'name', value: value }]))
      }
    }
  }

  const handleGroupChange = (group) => {
    setValueChanged(true)
    setSelectedGrp(group)
    if (group.value === -1) {
      setGroup({ ...group, hasError: true, errorMessage: t('event.create.clientErrors.groupRequired') })
    } else {
      setGroup({ ...group, hasError: false, errorMessage: '' })
      if (!editMode || previewEditMode) {
        dispatch(mixrActions.setMixrData([{ key: 'group', value: group.group }]))
      }
    }
  }
  const handleErrorFromInputArea = (error) => {
    if (error) {
      setDescription({
        ...description,
        hasError: true,
        errorMessage: error
      })
    } else {
      setDescription({
        ...description,
        hasError: false,
        errorMessage: ''
      })
    }
  }
  const handleDescChange = (content) => {
    setDescription({
      ...description,
      value: content,
      errorMessage: '',
      hasError: false

      //  errorMessage: content.length === 0 ? t('event.create.clientErrors.descriptionRequired') : '',
      //hasError: content.length === 0
    })
    if (!isEmpty(content) && !editMode) {
      dispatch(mixrActions.setMixrData([{ key: 'description', value: content }]))
    }
  }
  const handleDescFocus = () => {
    setFocusedMode(true)
    setValueChanged(true)
  }

  //https://github.com/facebook/react/issues/4210
  const handleDescBlur = (e) => {
    setTimeout(() => setFocusedMode(false), 500)
  }
  const handleNext = () => {
    if (validate()) {
      dispatch(
        mixrActions.setMixrData([
          { key: 'name', value: name.value },
          { key: 'description', value: description.value }
        ])
      )
      showNextSection()
    }
  }
  const handleSaveAddDraft = () => {
    if (validate()) {
      dispatch(
        mixrActions.setMixrData([
          { key: 'name', value: name.value },
          { key: 'description', value: description.value }
        ])
      )
      handleSaveDraft()
    }
  }

  const validate = () => {
    if (!editMode && selectedGrp.value === -1 && selectGroupRef.current) {
      selectGroupRef.current.focus()
      setGroup({ ...group, hasError: true, errorMessage: t('event.create.clientErrors.groupRequired') })
      return false
    }
    if (isEmpty(name.value) && nameRef.current) {
      nameRef.current.focus()
      setName({
        ...name,
        hasError: true,
        errorMessage: t('event.create.clientErrors.nameRquired')
      })
      return false
    }

    if (isEmpty(description.value) && descriptionRef.current) {
      descriptionRef.current.focus()
      setFocusedMode(true)
      setDescription({
        ...description,
        hasError: true,
        errorMessage: t('event.create.clientErrors.descriptionRequired')
      })
      return false
    } else {
      setDescription({
        ...description,
        hasError: false,
        errorMessage: ''
      })
    }

    return true
  }

  const isValid = () => {
    let isValid = true
    if (isEmpty(name.value)) {
      isValid = false
    }
    if (isEmpty(description.value)) {
      isValid = false
    }
    if (group.value === -1) {
      isValid = false
    }
    return isValid
  }

  const handleSave = () => {
    if (validate()) {
      const data = {
        name: name.value,
        description: description.value
      }
      if (recurrence && recurrence.type !== 'none' && recurrence.is_parent_event !== 1) {
        openEditMixrPopup()
        setDataToUpdateForRecMixr(data)
      } else {
        dispatch(mixrActions.editMixr(id, data))
      }
    }
  }
  const handleCancel = () => {
    setValueChanged(false)
    setName({
      ...name,
      value: mixrName
    })
    setDescription({
      ...description,
      value: mixrDescription
    })
  }

  return (
    <React.Fragment>
      <PureTitle
        title={t('event.create.basicInfo.selectGroupTitle')}
        subTitle={t('event.create.basicInfo.selectGroupSubTitle')}
        isRequired={true}
      />
      <div className={parentStyles.full}>
        <Dropdown1
          ref={selectGroupRef}
          setRef={setSelectGroupRefRef}
          size={'full'}
          value={selectedGrp}
          options={groups}
          errorMessage={group.errorMessage}
          onChange={handleGroupChange}
          isSearchable={false}
          loading={groupLoading}
        />
        {group && group.hasError && <ErrorMessage text={group.errorMessage} className={styles.error} />}
      </div>
      <PureTitle
        title={t('event.create.basicInfo.mixrNameTitle')}
        subTitle={t('event.create.basicInfo.mixrNameSubTitle')}
        isRequired={true}
      />
      <TextBox
        name='mixrName'
        isRequired={true}
        onChange={handleNameChange}
        onBlur={handleNameBlur}
        // onFocus={handleNameFocus}
        placeholder={t('event.create.basicInfo.mixrNamePlaceholder')}
        fieldInfo={name}
        size={'full'}
        customWrapperCss={styles.textboxWrapper}
        ref={nameRef}
        setRef={setNameRef}
        maxLength={60}
        customErrorCss={styles.error}
      />
      <PureTitle
        title={t('event.create.basicInfo.mixrDescTitle')}
        subTitle={t('event.create.basicInfo.mixrDescSubTitle')}
        isRequired={description.isRequired}
      />
      <div className={`${parentStyles.full} ${styles.mb16}`}>
        <div
          ref={descriptionRef}
          className={`${styles.editorContainer} ${
            focusedMode
              ? description.hasError
                ? styles.editorContainerErrorFocused
                : styles.editorContainerFocused
              : ''
          }`}
          onFocus={handleDescFocus}
          onBlur={handleDescBlur}>
          <RichTextEditor
            value={description.value}
            clearEditor={!description.value}
            showTextFormatter={true}
            showEmojiPicker={true}
            showFilePicker={false}
            placeholder={t('event.create.basicInfo.mixrDescPlaceholder')}
            handleChange={handleDescChange}
            //handleReturn={handleNext}
            containerCSS={styles.richTextAreaWrapper}
            charLimit={appConstantSettings.MAX_CHAR_COUNT}
            maxLines={appConstantSettings.MAX_LINES}
            handleInputError={handleErrorFromInputArea}
            //editorRef={editorRef}
            editorId={`mixrDesc`}
            errorMessageRequired={t('error.required', { field: t(`formlabel.${description.name}`) })}
            errorMessageLimitExceed={t('group.createGroup.groupDescription.charLimit', {
              charLimit: appConstantSettings.MAX_CHAR_COUNT
            })}
            keepFormatOnPopulate={true}
          />
        </div>
        {description && description.hasError && (
          <ErrorMessage text={description.errorMessage} className={styles.error} />
        )}
      </div>
      {editMode && !previewEditMode ? (
        valueChanged ? (
          <div className={parentStyles.buttons}>
            <Button style='secondary' text={t('global.cancel')} handleClick={handleCancel} />
            <Button
              type='button'
              handleClick={handleSave}
              text={
                editLoading && recurrence && (recurrence.type === 'none' || recurrence.is_parent_event === 1) ? (
                  <Spinner isWhite={true} />
                ) : (
                  t('global.save')
                )
              }
            />
          </div>
        ) : null
      ) : !hideNextButton ? (
        <React.Fragment>
          <div className={parentStyles.buttons}>
            <Button type='button' text={t('global.btnNext')} handleClick={handleNext} />
          </div>
          <Button
            type='button'
            size='small'
            text={t('global.btnSaveAddDraft')}
            customStyle={styles.btnSaveAddDraft}
            handleClick={handleSaveAddDraft}
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  )
}
